import { getMediaVariantCandidates } from "@/utils/mediaUrlVariants";

import type { ScheduledPost } from "../schedule/scheduledPost";
import type { DesignFile } from "./design-step/types";
import type { PostType } from "./post-type-step/postTypes";

import { useSocialPages } from "../../hooks/useSocialPages";
import { PlatformPostPreview } from "../schedule/post-preview/PlatformPostPreview";
import { isImageDesign } from "./design-step/isImageDesign";
import { isVideoDesign } from "./design-step/isVideoDesign";

export function PublicationPreview({
  brandId,
  caption = "",
  designs,
  postType,
  scheduledAt = new Date(),
}: {
  brandId: number;
  caption?: string;
  designs: DesignFile[];
  postType: PostType;
  scheduledAt?: Date;
}) {
  const { data } = useSocialPages();
  const page = data?.pages.find(
    (page) => page.brand.id === brandId && page.platform === postType.platform,
  );
  const [cover] = designs;

  if (!cover) return null;

  const videoDesign = designs.find((design) => isVideoDesign(design));

  const post: ScheduledPost = {
    account: { name: page?.username ?? page?.name ?? page?.brand.name ?? "" },
    brand: {
      id: brandId,
      name: page?.brand.name ?? "",
      primaryColor: null,
      profilePicture: null,
    },
    caption,
    format: postType.format,
    id: Number(cover.id),
    images: designs.flatMap((design) =>
      isImageDesign(design) && design.url
        ? [getMediaVariantCandidates(design.url, "preview")]
        : [],
    ),
    platform: postType.platform,
    scheduledAt,
    status: "scheduled",
    title: cover.name,
    video: videoDesign?.url
      ? {
          attachmentId: Number(videoDesign.id),
          extension: videoDesign.extension,
          url: videoDesign.url,
        }
      : null,
  };

  return <PlatformPostPreview post={post} />;
}
